import React from 'react';
import { motion } from 'framer-motion';
interface Props {
  eyebrow: string;
  title: React.ReactNode;
  subtitle?: string;
}
export function PageHero({
  eyebrow,
  title,
  subtitle
}: Props) {
  return <section className="relative overflow-hidden border-b border-white/10 bg-black" data-id="element-90" data-mp="3talms8xtzhr1">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-jk-red/20 blur-3xl" data-id="element-91" data-mp="22z8znhedywg" />
      <div className="pointer-events-none absolute left-0 top-0 h-full w-1.5 bg-jk-red" data-id="element-92" data-mp="pu4pm4v5wv7t" />
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20" data-id="element-93" data-mp="usfyac9q0zog">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="max-w-3xl" data-id="element-94" data-mp="g3a0msqj7hio">
          <div className="mb-3 flex items-center gap-2" data-id="element-95" data-mp="l00gbeyfcb3k">
            <span className="h-[3px] w-8 bg-jk-red" data-id="element-96" data-mp="18r5vrt0gd1dc" />
            <span className="font-display text-sm font-bold uppercase tracking-[0.25em] text-jk-red" data-id="element-97" data-mp="1dinyali4ja0f">{eyebrow}</span>
          </div>
          <h1 className="font-display text-5xl font-extrabold uppercase leading-[0.98] tracking-tight text-white sm:text-6xl sm:leading-[0.92]" data-id="element-98" data-mp="32hisktvgx31v">
            {title}
          </h1>
          {subtitle && <p className="mt-5 max-w-2xl text-lg leading-relaxed text-white/65" data-id="element-99" data-mp="3c8dhy740girj">{subtitle}</p>}
        </motion.div>
      </div>
    </section>;
}